import { useEffect, useRef } from 'react';

import { me, useSesionStore } from '@/entities/usuario';
import { refresh } from '@/features/refresh-session';

/**
 * Hidrata la sesion al montar la app:
 * 1. Intenta refresh para obtener un access token nuevo (cookie HttpOnly).
 * 2. Si el refresh tiene exito, llama /auth/me y popula el store.
 * 3. Marca isHydrated=true al terminar (exito o fallo) para que el guard
 *    pueda decidir.
 *
 * Idempotente: solo corre una vez por montaje del provider.
 */
export function useHidratarSesion(): void {
  const setHydrated = useSesionStore((s) => s.setHydrated);
  const setSesion = useSesionStore((s) => s.setSesion);
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return;
    ranRef.current = true;

    void (async () => {
      try {
        const { accessToken } = await refresh();
        useSesionStore.getState().setAccessToken(accessToken);
        const user = await me();
        setSesion({ accessToken, user });
      } catch {
        // No hay sesion previa o el refresh fallo. Esperado en primera visita.
      } finally {
        setHydrated(true);
      }
    })();
  }, [setHydrated, setSesion]);
}
